module.exports = __webpack_public_path__ + "static/media/iconProfile.14b802eb.svg";